import { memo } from 'react';

import { useGetSettingsQuery } from 'store/api/strapiService/rewardSystemController';

import Loader from 'components/UI/Loader/Loader';
import Typography from 'components/UI/Typography/Typography';
import TermsContent from 'components/pages/RewardSystem/Terms/TermsContent/TermsContent';

import styles from './Terms.module.scss';

const Terms = () => {
  const { data: settingsData, isLoading } = useGetSettingsQuery();

  const { termsAndConditions } = settingsData?.data ?? {};

  return (
    <div className={styles.root}>
      <Typography type="heading-md" weight="medium" uppercase>
        Reward system terms and conditions
      </Typography>
      {!isLoading ? <TermsContent content={termsAndConditions} /> : <Loader />}
    </div>
  );
};

export default memo(Terms);
